import { BenefitWizardType } from './wizard-panels';

/**
 * From Old MWP - hg-enrollment-wizard-toolbar
 * 
 */
export interface IBenefitEnrollmentButton {
    name: string;
    BenefitWizardType: BenefitWizardType,
    activatePropName: string,
    cssStyle: string,
    isCurrentBenefitSection: boolean;
}

const green: string = 'mwp-button-save alternate-hover';
const red: string = 'mwp-button-red alternate-hover';
const orange: string = 'mwp-button-orange alternate-hover';


const KeepCurrentElections: IBenefitEnrollmentButton = {
    name: 'Keep Current Election',
    BenefitWizardType: BenefitWizardType.Keep,
    activatePropName: 'isNoChangeAvailable',
    cssStyle: green,
    isCurrentBenefitSection: true,
};

const AddBenefit: IBenefitEnrollmentButton = {
    name: 'Add Benefit',
    BenefitWizardType: BenefitWizardType.Add,
    activatePropName: 'isAddAvailable',
    cssStyle: green,
    isCurrentBenefitSection: false,
};

const ReplaceCurrentBenefit: IBenefitEnrollmentButton = {
    name: 'Replace Benefit',
    BenefitWizardType: BenefitWizardType.Add,
    activatePropName: 'isReplaceAvailable',
    cssStyle: orange,
    isCurrentBenefitSection: true,
};

const ModifyCurrentBenefit: IBenefitEnrollmentButton = {
    name: 'Modify Benefit',
    BenefitWizardType: BenefitWizardType.BuyUp,
    activatePropName: 'isExistingBenefitEdit',
    cssStyle: orange,
    isCurrentBenefitSection: true,
};

const FSAReenroll: IBenefitEnrollmentButton = {
    name: 'FSA Re-enroll',
    BenefitWizardType: BenefitWizardType.FSA,
    activatePropName: 'isFSAReEnrollAvailable',
    cssStyle: green,
    isCurrentBenefitSection: true,
};

const CarrierEnrollment: IBenefitEnrollmentButton = {
    name: 'Carrier Enrollment',
    BenefitWizardType: BenefitWizardType.Widget,
    activatePropName: 'isWidgetAvailable',
    cssStyle: green,
    isCurrentBenefitSection: false,
};

const TermBenefit: IBenefitEnrollmentButton = {
    name: 'Terminate Benefit',
    BenefitWizardType: BenefitWizardType.Term,
    activatePropName: 'isTermAvailable',
    cssStyle: red,
    isCurrentBenefitSection: true,
};

const WaiveBenefit: IBenefitEnrollmentButton = {
    name: 'Waive Benefit',
    BenefitWizardType: BenefitWizardType.WaiveBenefit,
    activatePropName: 'isAddWaiveBenefitAvailable',
    cssStyle: orange,
    isCurrentBenefitSection: false,
};

const WaiveExistingBenefitOrRequest: IBenefitEnrollmentButton = {
    name: 'Waive Benefit',
    BenefitWizardType: BenefitWizardType.WaiveBenefit,
    activatePropName: 'isWaiveExistingBenefitOrRequestAvailable',
    cssStyle: orange,
    isCurrentBenefitSection: true,
};

const WaiveCoverage: IBenefitEnrollmentButton = {
    name: 'Waive - Continue',
    BenefitWizardType: BenefitWizardType.Waive,
    activatePropName: 'isWaiveAvailable',
    cssStyle: orange,
    isCurrentBenefitSection: false,
};

const CancelRequest: IBenefitEnrollmentButton = {
    name: 'Cancel Request',
    BenefitWizardType: BenefitWizardType.Cancel,
    activatePropName: 'isCancelAvailable',
    cssStyle: red,
    isCurrentBenefitSection: true,
};

export const BenefitEnrollmentButtonList = [
    KeepCurrentElections,
    AddBenefit,
    ReplaceCurrentBenefit,
    ModifyCurrentBenefit,
    FSAReenroll,
    CarrierEnrollment,
    TermBenefit,
    WaiveBenefit,
    WaiveCoverage,
    WaiveExistingBenefitOrRequest,
    CancelRequest
];